export const FETCH_START = 'AOR/FETCH_START';
export const FETCH_END = 'AOR/FETCH_END';
export const FETCH_ERROR = 'AOR/FETCH_ERROR';
export const FETCH_CANCEL = 'AOR/FETCH_CANCEL';
